import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import GrowingTextArea from '@wix/da-ds/pkg/formControls/lego/GrowingTextArea';
import { SubmissionStatus } from '../../../../../redux/form/types';
import { getCurrentSubmission } from '../../../../../redux/form/selectors';
import { FormAction } from '../../../usePromptFormAction';
import { useLogInputClickBiEvent, useLogInvalidPromptBiEvent, usePrompt } from './hooks';
const PromptTextArea = (_param)=>{
    var { formAction } = _param, rest = _object_without_properties(_param, [
        "formAction"
    ]);
    const { t } = useTranslation('dreamup');
    const [prompt, handleChange] = usePrompt();
    const currentSubmission = useSelector(getCurrentSubmission);
    const handleInvalid = useLogInvalidPromptBiEvent();
    const handleClick = useLogInputClickBiEvent();
    return /*#__PURE__*/ React.createElement(GrowingTextArea, _object_spread({
        autoComplete: "off",
        placeholder: t('dreamup.header.input.placeholder'),
        name: "prompt",
        value: prompt,
        maxRows: 6,
        maxLength: 400,
        onChange: handleChange,
        onInvalid: handleInvalid,
        onClick: handleClick,
        required: formAction === FormAction.SubmitPaidPrompt || formAction === FormAction.SubmitFreePrompt || formAction === FormAction.DisplayPromptGuidelinesModal || formAction === FormAction.RedirectToDreamupApp || formAction === FormAction.AnonJoin,
        disabled: currentSubmission.status === SubmissionStatus.AwaitingResponse
    }, rest));
};
PromptTextArea.displayName = 'PromptTextArea';
export default PromptTextArea;

//# sourceMappingURL=PromptTextArea.js.map